import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import { IState } from '@/store/modules/suppliers/types'

const state: IState = {
  isLoading: false,
  supplier: [],
}

export default {
  state,
  actions,
  getters,
  mutations,
}
